import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgSyringe = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M8.57837 17.865L5.9267 15.2133C5.81054 15.0972 5.7184 14.9594 5.65553 14.8077C5.59266 14.656 5.5603 14.4934 5.5603 14.3292C5.5603 14.1649 5.59266 14.0023 5.65553 13.8506C5.7184 13.6989 5.81054 13.5611 5.9267 13.445L13.44 5.9325L17.8567 10.3492L10.3442 17.8625C10.1102 18.0967 9.79285 18.2284 9.4618 18.2289C9.13076 18.2294 8.81304 18.0985 8.57837 17.865V17.865Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.15942 17.8653L6.36913 15.6556L8.1369 17.4234L5.92719 19.6331L4.15942 17.8653Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.83325 20.9583L5.04325 18.7483"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.114 4.60666L19.1848 11.6775"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7656 7.25807L17.8592 4.16448L19.627 5.93225L16.5334 9.02584L14.7656 7.25807Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5332 2.83833L20.9532 7.25833"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.4399 11.2358L15.2074 13.0033"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.7883 13.8875L12.5558 15.655"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgSyringe.displayName = 'SvgSyringe';
export default SvgSyringe;
